import { Backdrop, CircularProgress, Grid, Typography } from '@mui/material'

export const LoadingSpinnerMasterView = (props: { loading: boolean; message?: string; modalIndex?: boolean }) => {
  const { loading, message = '', modalIndex = false } = props

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: theme => (modalIndex ? theme.zIndex.modal + 1 : theme.zIndex.drawer + 1) }}
      open={loading}>
      <Grid item display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress color="inherit" />
        <Typography textAlign="center" whiteSpace="pre-line">
          {message}
        </Typography>
      </Grid>
    </Backdrop>
  )
}
